var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c("div", { staticClass: "t-wrapper__main" }, [
        _c(
          "div",
          { staticClass: "t-wrapper__content" },
          [
            _c(
              "portal",
              { attrs: { to: "header-main" } },
              [
                _c("h2", [
                  _c(
                    "span",
                    {
                      staticClass: "t-back t-dis--in-blk",
                      on: {
                        click: function ($event) {
                          return _vm.goBack()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("config.integrations.salesforce.title"))
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.salesforce.connected && _vm.salesforce.appName
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              `config.integrations.salesforce.connected_desc`,
                              {
                                name: _vm.salesforce.appName,
                              }
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("config.integrations.salesforce.outer_desc")
                          ) +
                          "\n      "
                      ),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "portal",
              { attrs: { to: "header-actions" } },
              [
                _vm.salesforce.connected
                  ? _c(
                      "t-button",
                      {
                        attrs: {
                          loading: _vm.disconnecting,
                          disabled: !!_vm.disabledTooltip,
                          tooltip: _vm.disabledTooltip,
                          variant: "danger",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.disconnectFromSalesforce()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "mdi mdi-salesforce mdi-21px" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "t-mar--l-ti" }, [
                          _vm._v(
                            _vm._s(_vm.$t("config.integrations.disconnect"))
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-integ__sections t-mar--t-no" },
              [
                _vm.sfEnabledForWorkspace && _vm.salesforce.connected
                  ? [
                      !_vm.package_installed
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "t-integ__step t-mar--b-sm" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "t-integ__header t-mar--b-sm",
                                  },
                                  [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("h4", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "config.integrations.salesforce.add_package_title"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "config.integrations.salesforce.add_package_desc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c("div", { staticClass: "t-integ__details" }, [
                                  _c("p", { staticClass: "t-mar--t-st" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "config.integrations.salesforce.details_title"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", [
                                    _c("li", { staticClass: "t-mar--b-xs" }, [
                                      _vm._v(
                                        "→ " +
                                          _vm._s(
                                            _vm.$t(
                                              "config.integrations.salesforce.details_point1"
                                            )
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "→ " +
                                          _vm._s(
                                            _vm.$t(
                                              "config.integrations.salesforce.details_point2"
                                            )
                                          )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "t-flex t-flex--aic" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "t-button t-button--primary t-button--small t-fw--medium t-mar--r-sm",
                                          attrs: {
                                            href: _vm.install_url,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "t-tc--white mdi mdi-open-in-new mdi-21px t-mar--r-ti",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "t-tc--white t-tf--bolder",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "config.integrations.salesforce.add_package"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "config.integrations.salesforce.already_added"
                                            )
                                          ) + " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "t-tc--link t-cursor--pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.refreshPackageCheck()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "config.integrations.salesforce.refresh"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "t-integ__status t-mar--t-st t-integ__status--warn",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-shield-alert mdi-24px t-mar--r-mi",
                                      }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("h6", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "config.integrations.salesforce.before_installation.title"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "config.integrations.salesforce.before_installation.desc"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "t-integ__step t-integ__step--disabled",
                              },
                              [
                                _c("div", { staticClass: "t-integ__header" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "config.integrations.salesforce.sync_setting_title"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "config.integrations.salesforce.sync_setting_desc"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.package_installed
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "t-integ__status t-integ__status--success t-mar--b-sm",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "mdi mdi-shield-check mdi-24px t-mar--r-mi",
                                }),
                                _vm._v(" "),
                                _c("h6", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "config.integrations.salesforce.package_installed"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "t-integ__step" }, [
                              _c(
                                "div",
                                { staticClass: "t-integ__header t-mar--b-sm" },
                                [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "config.integrations.salesforce.sync_setting_title"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "config.integrations.salesforce.sync_setting_desc"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "t-integ__details t-mar--t-st" },
                                [
                                  _c("t-checkbox", {
                                    attrs: {
                                      loading: _vm.settingsLoader,
                                      label: _vm.$t(
                                        "config.integrations.salesforce.create_contact_if_missing"
                                      ),
                                      description: _vm.$t(
                                        "config.integrations.salesforce.create_contact_if_missing_desc"
                                      ),
                                      name: "create_contact_if_missing",
                                    },
                                    on: { update: _vm.update },
                                    model: {
                                      value: _vm.createMissingContact,
                                      callback: function ($$v) {
                                        _vm.createMissingContact = $$v
                                      },
                                      expression: "createMissingContact",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.sfEnabledForWorkspace || !_vm.salesforce.connected
                  ? [
                      !_vm.sfEnabledForWorkspace
                        ? _c(
                            "div",
                            { staticClass: "t-flex t-flex--aic t-mar--b-st" },
                            [
                              _c("i", {
                                staticClass:
                                  "mdi mdi-lightning-bolt mdi-21px t-mar--r-ti t-tc--link",
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("config.access_limit.salesforce")
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.salesforce.connected
                        ? _c("div", { staticClass: "t-integ__card" }, [
                            _c(
                              "div",
                              { staticClass: "t-integ__connect" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/lib/assets/images/integrations/salesforce-logo.png"),
                                    alt: "salesforce",
                                    height: "150",
                                    width: "214",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "t-integ__connect_title t-mar--t-lg",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "config.integrations.salesforce.connect_section_title"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "t-integ__connect_desc t-mar--t-mi",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "config.integrations.salesforce.connect_section_desc"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "t-button",
                                  {
                                    staticClass: "t-shadow--dp1 t-mar--t-lg",
                                    attrs: {
                                      variant: "primary",
                                      loading: _vm.connecting,
                                      disabled: !!_vm.disabledTooltip,
                                      tooltip: _vm.disabledTooltip,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.connectToSalesforce()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-salesforce mdi-21px",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "t-mar--l-ti" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("config.integrations.connect")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "t-integ__icon" }, [
      _c("img", {
        attrs: {
          src: require("@/lib/assets/images/Trainn-Logo-Assets/SVG/Trainn-logo-white.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "t-integ__icon" }, [
      _c("i", { staticClass: "mdi mdi-transit-connection-variant mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "t-integ__icon" }, [
      _c("i", { staticClass: "mdi mdi-transit-connection-variant mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }